export const abhaCardCreateTranslations = {
    en: {
  
            fetchOpdFailed: "Failed to fetch OPD numbers!",
            submitSuccess: "ABHA card application submitted successfully!",
            submitFailed: "Failed to submit ABHA application!",
            submitting: "Submitting...",
            submit: "Submit",

            patientInformation: "Patient Information",
            tokenNo: "Token No",
            tokenPlaceholder: "Search Token No eg. 00005",
            beneficiaryName: "Beneficiary Name",
            date: "Date",

            identificationDetails: "Identification Details",
            identificationType: "Identification Type",
            aadhaarNumber: "Aadhaar Number",
            aadhaarPlaceholder: "e.g., 123456789012",
            drivingLicense: "Driving License",
            drivingLicensePlaceholder: "e.g., DL01234567890123",

            personalDetails: "Personal Details",
            fullName: "Full Name",
            dateOfBirth: "Date Of Birth",
            mobileNumber: "Mobile Number",
            mobilePlaceholder: "e.g., 9876543210",
            email: "Email",
            emailPlaceholder: "e.g., example@domain.com",
            guardianName: "Guardian Name",
            guardianPlaceholder: "Enter Guardian Name",
            gender: "Gender",

            contactAndAddress: "Contact and Address",
            pincode: "Pin code",
            pincodePlaceholder: "e.g., 422605",
            district: "District",
            districtPlaceholder: "Select District",
            taluka: "Taluka",
            talukaPlaceholder: "Select Taluka",
            address: "Address",

            remarks: "Remarks",
            remark: "Remark",
            consentTitle: "Consent for ABHA Card Creation",
            consentText: "I confirm that the information filled above is correct and I give my consent for the creation of my ABHA Card."
    },
    mr: {
       
            fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
            submitSuccess: "आभा कार्ड अर्ज यशस्वीरित्या सबमिट केला!",
            submitFailed: "आभा अर्ज सबमिट करण्यात अयशस्वी!",
            submitting: "सबमिट करत आहे...",
            submit: "सबमिट करा",

            patientInformation: "रुग्ण माहिती",
            tokenNo: "टोकन क्रमांक",
            tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
            beneficiaryName: "लाभार्थीचे नाव",
            date: "तारीख",

            identificationDetails: "ओळख तपशील",
            identificationType: "ओळख प्रकार",
            aadhaarNumber: "आधार क्रमांक",
            aadhaarPlaceholder: "उदा., 123456789012",
            drivingLicense: "ड्रायव्हिंग लायसन्स",
            drivingLicensePlaceholder: "उदा., DL01234567890123",

            personalDetails: "वैयक्तिक तपशील",
            fullName: "पूर्ण नाव",
            dateOfBirth: "जन्मतारीख",
            mobileNumber: "मोबाईल नंबर",
            mobilePlaceholder: "उदा., 9876543210",
            email: "ईमेल",
            emailPlaceholder: "उदा., example@domain.com",
            guardianName: "पालकाचे नाव",
            guardianPlaceholder: "पालकाचे नाव प्रविष्ट करा",
            gender: "लिंग",

            contactAndAddress: "संपर्क आणि पत्ता",
            pincode: "पिन कोड",
            pincodePlaceholder: "उदा., 422605",
            district: "जिल्हा",
            districtPlaceholder: "जिल्हा निवडा",
            taluka: "तालुका",
            talukaPlaceholder: "तालुका निवडा",
            address: "पत्ता",

            remarks: "शेरा",
            remark: "टिप्पणी",
            consentTitle: "आभा कार्ड तयार करण्यासाठी संमती",
            consentText: "मी पुष्टी करतो की वर भरलेली माहिती बरोबर आहे आणि मी माझ्या आभा कार्डच्या निर्मितीसाठी संमती देतो."
        }
    
};
